import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DevicePilomat } from '../model/devicePilomat';
import { ProgrammedExecution } from '../model/programmedExecution';
import { DeviceService } from '../service/device.service';
import { TimeSlotDialogComponent } from '../time-slot-dialog/time-slot-dialog.component';
import { Log } from '../util/log';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { StringHelper } from '../util/stringHelper';
import { TimeSlotHelper } from '../util/timeSlotHelper';
import { Overlay } from '@angular/cdk/overlay';
import { FormControl } from '@angular/forms';
import { DateHelper } from '../util/dateHelper';

import * as moment from 'moment';
import 'moment-timezone';
import { DateAdapter } from '@angular/material/core';
import { NgxMatDateAdapter } from '@angular-material-components/datetime-picker';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';


@Component({
  selector: 'app-add-programmed-executions',
  templateUrl: './add-programmed-executions.component.html',
  styleUrls: ['./add-programmed-executions.component.css']
})
export class AddProgrammedExecutionsComponent implements OnInit {

  @Output()
  dateChange: EventEmitter<MatDatepickerInputEvent<any>> = new EventEmitter();

  @ViewChild('loader', { static: true }) loader;


  invalidDatesError: boolean = false;
  noDeviceSelectedError: boolean = false;

  programmedExecution: ProgrammedExecution;

  devices: DevicePilomat[] = [];
  selectedDevices: string[] = [];

  //per limitare momentaneamente alla scelta di un unico device
  deviceSelected: boolean = false;

  description: string = "";

  fromFormControl: FormControl;
  toFormControl: FormControl;
  minDate: Date = new Date();

  @ViewChild('deviceslisttable', { static: true }) table;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  displayedColumns: string[] = [
    'serial',
    'name',
    'checkbox'
  ];

  constructor(
    private deviceService: DeviceService,
    private overlay: Overlay,
    public dialogRef: MatDialogRef<AddProgrammedExecutionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private dateAdapter: NgxMatDateAdapter<any>
  ) {
    this.dateAdapter.setLocale($localize`:@@add_programmed_execution_dialog_datepicker_locale:it-IT`);

    this.devices = data.devices;
    this.selectedDevices = [];
    for (let i = 0; i < this.devices.length; i++) {
      this.devices[i].selected = false;
    }

    // if (data.execution) {
    //   console.log(data.execution);
    //   console.log(data.execution.serial);

    //   this.programmedExecution = ProgrammedExecution.createCopy(data.execution);

    //   this.selectedDevices.push(data.execution.serial);

    //   for (let i = 0; i < this.devices.length; i++) {
    //     if (this.devices[i].serial == data.execution.serial) {
    //       this.devices[i].selected = true;
    //     }
    //   }
    // } else {
    // console.log("no execution in data");
    this.programmedExecution = new ProgrammedExecution();
    this.programmedExecution.fromDate = new Date();
    this.programmedExecution.toDate = new Date();
    this.programmedExecution.toDate.setDate(this.programmedExecution.toDate.getDate() + 1);
    // }
    this.programmedExecution.fromDate.setMinutes(this.round5minup(this.programmedExecution.fromDate.getMinutes()));
    this.programmedExecution.toDate.setMinutes(this.round5minup(this.programmedExecution.toDate.getMinutes()));
    this.programmedExecution.fromDate.setSeconds(0);
    this.programmedExecution.toDate.setSeconds(0);
    this.fromFormControl = new FormControl(this.programmedExecution.fromDate);
    this.toFormControl = new FormControl(this.programmedExecution.toDate);
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.table.dataSource = new MatTableDataSource(this.devices);
    this.table.dataSource.sort = this.sort;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  addSelectedDevice(device) {

    if (device.selected) {
      this.deviceSelected = false;
      for (let i = 0; i < this.selectedDevices.length; i++) {
        if (this.selectedDevices[i] == device.serial) {
          this.selectedDevices.splice(i, 1);
        }
      }
      device.selected = false;
    } else {
      this.selectedDevices.push(device.serial);
      this.deviceSelected = true;
      device.selected = true;
    }
  }


  createExecution() {
    this.invalidDatesError = false;
    this.noDeviceSelectedError = false;

    let from: Date;
    if (this.fromFormControl.value) {
      from = new Date(this.fromFormControl.value);
    } else {
      from = new Date(this.programmedExecution.fromDate);
    }

    let to: Date;
    if (this.toFormControl.value != null) {
      to = new Date(this.toFormControl.value);
    } else {
      to = new Date(this.programmedExecution.toDate);
    }

    if (to < from) {
      this.invalidDatesError = true;
    } else if (this.selectedDevices.length == 0) {
      this.noDeviceSelectedError = true;
    } else {
      this.loader.showLoading();

      from.setMinutes(this.round5minup(from.getMinutes()));
      to.setMinutes(this.round5minup(to.getMinutes()));

      this.programmedExecution.from = DateHelper.formatDateRFC3339(from);
      this.programmedExecution.to = DateHelper.formatDateRFC3339(to);
      this.programmedExecution.operationType = ProgrammedExecution.OperationTypeForcedLow;

      this.programmedExecution.timeZone = moment.tz.guess();
      this.programmedExecution.description = this.description;

      this.createProgrammedExecutions(0);
    }
  }

  createProgrammedExecutions(index: number) {
    if (index < this.selectedDevices.length) {
      this.programmedExecution.serial = this.selectedDevices[index];
      this.deviceService.updateProgrammedExecution(this.selectedDevices[index], this.programmedExecution).subscribe((response) => {
        this.createProgrammedExecutions(index + 1);
      }, (err) => {
        Log.debug(err);
        this.dialogRef.close("Error");
      });
    } else {
      setTimeout(() => {
        this.dialogRef.close("Success");
      }, 250);
    }
  }

  //round to next 30 min increment (0,30 etc )
  round30minup(x) {
    return Math.ceil(x / 30) * 30;
  }

  round5minup(x) {
    return Math.ceil(x / 5) * 5;
  }

  // onChange(): void {
  //   console.log(" in: checkSelectedDates");
  //   console.log(this.programmedExecution.fromDate);
  //   console.log(this.programmedExecution.toDate);

  //   this.programmedExecution.fromDate.setMinutes(this.round5minup(this.programmedExecution.toDate.getMinutes()));
  //   this.programmedExecution.toDate.setMinutes(this.round5minup(this.programmedExecution.toDate.getMinutes()));
  // }

  // checkSelectedDates() {
  //   console.log(" in: checkSelectedDates");
  //   console.log(this.programmedExecution.fromDate);
  //   console.log(this.programmedExecution.toDate);

   
  //   console.log(this.programmedExecution.toDate);
  //   this.fromFormControl.updateValue(this.programmedExecution.fromDate);
  //   this.dateChange.emit();
  //   this.cdRef.detectChanges();
  // }

  // printDates(){
  //   this.programmedExecution.fromDate.setMinutes(this.programmedExecution.fromDate.getMinutes()+5);
  //   console.log(this.programmedExecution.fromDate);
  //   console.log(this.programmedExecution.toDate);
  // }
}
